<template>

<div id="relatorio-app">
    
    <vs-popup fullscreen title="Parâmetros de Relatórios" :active.sync="sbListaRelatoriosActive">
      <vs-row style="height: calc(100vh - 150px)">
        <vs-col vs-align="left" vs-w="4">
          <vs-alert><small>1. Selecione o relatório:</small></vs-alert> 
          <vs-collapse type="border" accordion class="p-0 mt-2" style="height: calc(100vh - 200px); overflow-y: auto">
              <vs-collapse-item><div slot="header" style="font-weight: 500">Financeiro</div>
                <ul class="mt-0">
                  <li @click="exibirParametros('Inadimplentes', 'Inadimplentes')">- Inadimplentes </li>
                  <li @click="exibirParametros('FluxoCaixa', 'Fluxo de Caixa')" class="mt-1" v-if="isGestor">- Fluxo de Caixa </li>
                  <li @click="exibirParametros('ReceitasAnalitico', 'Receitas Analítico')" class="mt-1" v-if="isGestor">- Receitas Analítico </li>
                  <li @click="exibirParametros('ReceitasConsolidado', 'Receitas Consolidado')" class="mt-1" v-if="isGestor">- Receitas Consolidados </li>
                  <li @click="exibirParametros('ReceitasPorPeriodo', 'Receitas Por Período')" class="mt-1" v-if="isGestor">- Receitas Por Período </li>
                  <li @click="exibirParametros('DespesasAnalitico', 'Despesas Analítico')" class="mt-1" v-if="isGestor">- Despesas Analítico </li>
                  <li @click="exibirParametros('DespesasConsolidado', 'Despesas Consolidado')" class="mt-1" v-if="isGestor">- Despesas Consolidado </li>
                  <li @click="exibirParametros('DespesasPorPeriodo', 'Despesas por Período')" class="mt-1" v-if="isGestor">- Despesas por Período </li>
                </ul>
              </vs-collapse-item>  
              <vs-collapse-item><div slot="header">Contabilidade</div>
                <ul>
                  
                </ul>
              </vs-collapse-item>
              
              <vs-collapse-item><div slot="header">Estoque</div>
                <ul>
                  
                </ul>
              </vs-collapse-item>
              
          </vs-collapse>
        </vs-col>
        <vs-col vs-align="left" vs-w="4">
            <vs-alert class="ml-2 mr-4"><small> 2. Informe os filtros</small></vs-alert>
           
            <label class="ml-2 mr-2 mt-3"><small>Período</small></label>
            <div class="flex ml-2 mr-2 mb-2 justify-center w-full">          
               <vx-input-group>    
                   <flat-pickr v-model="filtroDataInicio" :config="configDatePicker" :disabled="filtroPeriodoCarregamento" />
                   <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button color="primary" type="border" @click="filtroDataInicio = null"><small>X</small></vs-button>
                          </div>
                   </template>
                </vx-input-group>                  

                <label class="ml-2 mr-2 mt-3 text-sm">à</label>                

                <vx-input-group>    
                   <flat-pickr v-model="filtroDataFim"  :config="configDatePicker" :disabled="filtroPeriodoCarregamento"/>
                   <template slot="append">
                        <div class="append-text btn-addon">
                          <vs-button color="primary" type="border" @click="filtroDataFim = null"><small>X</small></vs-button>
                          </div>
                   </template>
                </vx-input-group>     
            </div>
            <div class="flex justify-center" >
                <vs-button size="small" class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left" @click="setMes(false)"> </vs-button>
                <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-calendar" @click="setMesAtual"></vs-button>
                <vs-button size="small" class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-arrow-right" @click="setMes(true)"> </vs-button>
            </div>
            <div class="flex ml-2 mr-2 mt-2 justify-center w-full">          
              <vs-checkbox v-model="filtroExibirEnviadoParaJuridico" v-if="exibirFiltroExibirEnviadoParaJuridico"> Exibir só enviados para o jurídico ? </vs-checkbox>
            </div>
        </vs-col>
        <vs-col vs-w="4">          
          <vs-alert class="ml-6 mr-6"><small>3. Clique no botão VER</small></vs-alert>
          <div class="w-full text-center mt-2"> 
             <h4 class="text-primary font-bold"> {{getNomeRelatorio}} </h4>
          </div>
          <div class="btn-group flex items-center justify-center mt-3">
            <vs-button size="small" @click="gerar('TELA')">VER</vs-button>
            <vs-button size="small" color="success" @click="sbListaRelatoriosActive=!sbListaRelatoriosActive">Fechar</vs-button>       
          </div>
          <div class="w-full"> 
               <vs-alert class="ml-6 mr-6 mt-4 " color="danger" :active.sync="exibirMensagemErro" closable icon-pack="feather" close-icon="icon-x" icon="icon-info">
                  {{mensagemErro}}
              </vs-alert> 
          </div>
           
        </vs-col>
      </vs-row>
    </vs-popup>
          
    <div style="position: fixed; right: 10px; left: 90px; top: 20px; z-index: 2; ">
      <vx-card >
          <div class="flex" >
              <vx-tooltip text="Atualizar dados do relatório" position="bottom">               
              <vs-button icon-pack="feather" icon="icon-refresh-cw" @click="gerar('TELA')" class="mr-2" :disabled="!dadosPDF"></vs-button>
              </vx-tooltip>
              <vs-button @click="sbListaRelatoriosActive=!sbListaRelatoriosActive" color="primary" type="filled" class="mr-4">PARÂMETROS</vs-button>
              <vs-button @click="page = 1" icon-pack="feather" icon="icon-chevrons-left" color="dark" :disabled="page == 1 || !dadosPDF"></vs-button>
              <vs-button @click="page = page - 1" icon-pack="feather" icon="icon-chevron-left" class="ml-2" color="dark" :disabled="page == 1 || !dadosPDF"></vs-button>
              <vs-button @click="page = page + 1" icon-pack="feather" icon="icon-chevron-right" class="ml-2" color="dark" :disabled="page == pageCount || !dadosPDF"></vs-button>  
              <vs-button @click="page = pageCount" icon-pack="feather" icon="icon-chevrons-right" class="ml-2" color="dark" :disabled="page == pageCount || !dadosPDF"></vs-button>  
              <vs-button @click="zoomOut" icon-pack="feather" icon="icon-zoom-out" class="ml-8" color="rgb(62, 201, 214)" :disabled="stylePDFWidth === 30 || !dadosPDF"></vs-button> 
              <vs-button @click="zoomIn" icon-pack="feather" icon="icon-zoom-in" class="ml-2" color="rgb(62, 201, 214)" :disabled="stylePDFWidth === 100 || !dadosPDF"></vs-button>               
              <vs-button @click="$refs.pdf.print()" icon-pack="feather" icon="icon-printer" class="ml-8" color="dark" :disabled="!dadosPDF"></vs-button>
              <vx-tooltip text="Exportar para PDF" position="bottom">               
              <vs-button @click="gerar('PDF')" icon="picture_as_pdf" class="ml-2" color="danger" :disabled="!dadosPDF"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="Exportar para Excel" position="bottom">               
              <vs-button @click="gerar('XLS')" icon="description" color="success" class="ml-2" :disabled="!dadosPDF"></vs-button>
              </vx-tooltip>              
              <h3 class="ml-6 mt-2" v-if="dadosPDF"> Página {{ currentPage }} de {{pageCount}}</h3>
              <h5 class="ml-6 mt-3" v-if="dadosPDF"> zoom: {{stylePDFWidth}}%</h5>
          </div>
      </vx-card>
    </div>    
    <vx-card style="position: relative; top: 80px;">
          <vs-alert color="danger" title="Atenção" :active.sync="exibirMensagemNenhumDadoEncontrado" closable icon-pack="feather" close-icon="icon-x">
              Não existem dados para os parâmetros informados.
          </vs-alert>
          <pdf v-if="dadosPDF" ref="pdf" :src="dadosPDF" :page="page" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" :style="{display: stylePDFDisplay, width: stylePDFWidth+'%'}" style="position: relative; border-style: solid; border-width: 1px;"></pdf>
    </vx-card>  
</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from "@/axios.js"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';

export default {
  components: {    
    flatPickr,
    VuePerfectScrollbar
  },   
  data() {
    return {   
      page: 1,
      currentPage: 0,
      pageCount: 0,      
      loadedRatio: 0,
      stylePDFDisplay: 'inline-block',
      stylePDFWidth: 100,
      sbListaRelatoriosActive: true,
      isHabilitarHora: false,
      nomeRelatorioAtivo: null,
      descricaoNomeRelatorioAtivo: null,
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center w-full",
          locale: PortugueseLocale,  
          enableTime: false                
      },       
      filtroDataInicio: null,      
      filtroDataFim: null, 
      dadosPDF: null,
      exibirMensagemNenhumDadoEncontrado: false,      
      exibirMensagemErro: false,
      mensagemErro: null,
      publicPath: process.env.BASE_URL,
      numeroMesAtual: 0,
      filtroExibirEnviadoParaJuridico: false,
      exibirFiltroExibirEnviadoParaJuridico: false
    }
  },  
  methods: {
    setMes(incrementar){
      
      if (incrementar) {
        this.numeroMesAtual = this.numeroMesAtual + 1;
      } else {
        this.numeroMesAtual = this.numeroMesAtual - 1;
      }

      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth() + this.numeroMesAtual, 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + this.numeroMesAtual, 0);


      this.filtroDataInicio = firstDay.toISOString().split('T')[0];
      this.filtroDataFim = lastDay.toISOString().split('T')[0];
    },
    setMesAtual(){
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtroDataInicio = firstDay.toISOString().split('T')[0];
      this.filtroDataFim = lastDay.toISOString().split('T')[0];
      this.numeroMesAtual = 0;
    },
    zoomIn() {
        if (this.stylePDFWidth < 100) {
          this.stylePDFWidth = this.stylePDFWidth + 10;
        }
    }, 
    zoomOut() {
        if (this.stylePDFWidth > 0) {
          this.stylePDFWidth = this.stylePDFWidth - 10;
        }
    },    
    isCamposValidos() {
      let mensagem = "";
      let nomeRelatorio = this.nomeRelatorioAtivo;

      if (!nomeRelatorio || nomeRelatorio === '1') {
         mensagem = "Selecione um relatório"
      }

      if (nomeRelatorio !== 'Inadimplentes' && (!this.filtroDataInicio || this.filtroDataInicio === '')) {
         mensagem = mensagem + "\n" + "Selecione a data de início"
      }

      if (!this.filtroDataFim || this.filtroDataFim === '') {
         mensagem = mensagem + "\n" + "Selecione a data fim"
      }

      if (mensagem !== "") {
        this.mensagemErro = mensagem;
        this.exibirMensagemErro  = true;
        return false;
      } else {
        this.exibirMensagemErro = false;
        return true;
      }
    },
    gerar(pTipoFormato) {
        let formatoExportacao = pTipoFormato;

        let urlRelatorio = "/Relatorio/GerarPDF";

        if (formatoExportacao === 'TELA') {
          formatoExportacao = 'PDF';
        } else if ( formatoExportacao === 'XLS') {
          urlRelatorio = "/Relatorio/GerarPDF";
        }

        if (!this.isCamposValidos()) {
          return;          
        }

        
                
        this.$vs.loading();
        const params = new URLSearchParams();    
        if (this.filtroDataInicio) {
          params.append('dataInicio', this.filtroDataInicio);
        }
        if (this.filtroDataFim) {
          params.append('dataFim', this.filtroDataFim);               
        }
        params.append('nomeRelatorio', this.nomeRelatorioAtivo);

        if (this.exibirFiltroExibirEnviadoParaJuridico) {          
          params.append('exibirEnviadoParaJuridico', this.filtroExibirEnviadoParaJuridico);
        }

        params.append('formatoExportacao', formatoExportacao);
        
        axios.post(urlRelatorio, params, {              
                timeout: 600000, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true,  responseType: 'arraybuffer' } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                
                  this.$router.push({ path: '/login' });  // Efetuar logoff
            } else {                                                
                if (pTipoFormato === 'TELA') {
                    this.sbListaRelatoriosActive = false;                
                    this.dadosPDF = new Uint8Array(response.data);
                    
                    if (!this.dadosPDF || this.dadosPDF.length < 2000) {
                      this.exibirMensagemNenhumDadoEncontrado = true;
                      this.dadosPDF = null;
                    } else {                
                      this.exibirMensagemNenhumDadoEncontrado = false;
                      this.page = 1;                  
                    }
                } else {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', this.nomeRelatorioAtivo + '.' + pTipoFormato.toLowerCase());
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            this.$vs.loading.close();
        }) 
    }, 
    exibirParametros(pRelatorio, pDescricaoNome) {    
      this.nomeRelatorioAtivo = pRelatorio;    
      this.descricaoNomeRelatorioAtivo = pDescricaoNome;      

      if (pRelatorio === 'Inadimplentes') {
        this.exibirFiltroExibirEnviadoParaJuridico = true; 
      } else {
        this.exibirFiltroExibirEnviadoParaJuridico = false; 
      }
    },    
  },
  computed: {
    getNomeRelatorio() {
      if (this.descricaoNomeRelatorioAtivo) {
        return this.descricaoNomeRelatorioAtivo;
      }

      return "Nenhum relatório selecionado.";
    },
    isGestor() {
			return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
		}
  },  
  mounted() {    
    this.setMesAtual();   
  },
  beforeDestroy() { 
    this.sbListaRelatoriosActive = false;
  },
  created(){
   
  }
}

</script> 

<style lang="scss" scoped>    
  .tabelaComScroll {
    overflow: auto;  
    height: calc(50vh - 120px);
    position: relative;
  }
</style>
<style lang="scss">
  #relatorio-app {
    height: calc(100vh - 65px); 
  }
  .h-100 {
        overflow-x: hidden;        
        overflow-y: auto;
        height: calc(100vh - 200px); 
        position: relative;
  }  
 .sidebarx.sidebarrelatorios{        
    .vs-sidebar--items {
      overflow-y: auto;
      overflow-x: hidden;
    }
    .vs-sidebar-group {      
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      max-height: 250px;
      h4 {
        font-size: 1rem;
        text-transform: uppercase;
      }
    }    
 }

  
</style>